import { inputClasses, ISearchInputProps, SearchInput } from '@private/components';
import styled from 'styled-components';

import { ThemedElement } from 'utils/types';

import { getInputTheme } from '../Input/styled';

export const StyledSearchInput = styled(SearchInput)<
  ThemedElement<ISearchInputProps & { $sizeVariant?: 'lg' | 'md' | 'sm' }>
>`
  ${({ $sizeVariant = 'lg' }) => getInputTheme(['components', 'input', $sizeVariant])};

  ${inputClasses.input} {
    max-height: ${({ $sizeVariant = 'lg' }) => {
      switch ($sizeVariant) {
        case 'lg':
          return 48;
        case 'md':
          return 40;
        default:
          return 32;
      }
    }}px;
  }

  ${inputClasses.input} {
    padding-top: 20px;
    padding-left: 49px;
  }

  ${inputClasses.iconButton} {
    min-height: 29px;
  }
`;
